import { createReducer, on } from '@ngrx/store';
import * as SalesRepActions from './sales-rep.actions';
import { SalesRep } from './sales-rep.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface SalesRepsState {
    salesReps: SalesRep[];
    isLoading: boolean;
    error: string | null;
}

export interface SalesRepState {
    salesRep: SalesRep;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialSalesRepsState: SalesRepsState = {
    salesReps: [],
    isLoading: false,
    error: null,
};

export const initialSalesRepState: SalesRepState = {
    salesRep: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All SalesReps Reducer
export const salesRepsReducer = createReducer(
    initialSalesRepsState,

    // On Load SalesReps
    on(SalesRepActions.loadSalesReps, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SalesRepActions.loadSalesRepsSuccess, (state, { salesReps }) => ({
        ...state,
        isLoading: false,
        salesReps: salesReps,
    })),
    on(SalesRepActions.loadSalesRepsFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(SalesRepActions.createSalesRep, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SalesRepActions.createSalesRepSuccess, (state, { salesRep }) => ({
        ...state,
        isLoading: false,
        salesReps: [...state.salesReps, salesRep],
    })),
    on(SalesRepActions.createSalesRepFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(SalesRepActions.updateSalesRep, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SalesRepActions.updateSalesRepSuccess, (state, { salesRep }) => ({
        ...state,
        isLoading: false,
        salesReps: state.salesReps.map((rep) =>
            rep.id === salesRep.id ? salesRep : rep
        ),
    })),
    on(SalesRepActions.updateSalesRepFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(SalesRepActions.deleteSalesRep, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SalesRepActions.deleteSalesRepSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        salesReps: state.salesReps.filter((rep) => rep.id !== id),
    })),
    on(SalesRepActions.deleteSalesRepFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);

// Single SalesRep Reducer
export const salesRepReducer = createReducer(
    initialSalesRepState,

    // On Load Single SalesRep
    on(SalesRepActions.loadSalesRep, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(SalesRepActions.loadSalesRepSuccess, (state, { salesRep }) => ({
        ...state,
        isLoading: false,
        salesRep: salesRep,
    })),
    on(SalesRepActions.loadSalesRepFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
